/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { hasCapability } from 'util/CapabilityUtil';
import { isExplore } from 'util/AssetUtil';
import { STARTING_POINTS } from '../../layout/explorecontainer/ExploreViewModel';
export default class OpenActionHandler {

	constructor() {}

	canExecute(options) {
		const selection = options.target && options.target.activeObject && options.target.activeObject.aSelectedContext;

		return isExplore(selection) && hasCapability(options.glassContext);
	}

	isItemVisible(options) {
		return this.canExecute(options);
	}

	doAction(options) {
		const id = options.target.activeObject.aSelectedContext[0].id;

		// Make an 'edited' call to the instrumentation service when we open an existing explore
		this._instrumentationTrack(id, options.glassContext);

		return this.openExplore(options.glassContext.appController, id);
	}


	_instrumentationTrack(id, glassContext) {
		const instrumentation = glassContext.getCoreSvc('.Instrumentation');
		if (instrumentation.enabled) {
			const objectType = 'explore';
			const action = 'edited';
			const payload = {
				type: 'Read Object',
				objectType,
				object: id,
				action,
				milestoneName: `${action}_${objectType}`
			};
			instrumentation.track(payload);
		}
	}

	onSelectItem(options) {
		return this.doAction(options);
	}

	// Private

	openExplore(appController, id) {
		return appController.openAppView('explore', {
			id,
			content: {
				boardId: id,
				isAuthoringMode: true,
				// build a complete urlMap context for dashboard/story
				objRef: id
			}
		}).then((view) => {
			const displayedCard = view.currentContentView.boardModel.layout.exploreVM.displayedCard;
			const isNewStartingPoints = !view.currentContentView.isFeatureEnabled('newStartingPoints', 'false');
			return displayedCard && displayedCard === STARTING_POINTS && isNewStartingPoints === false ? view.currentContentView.openDatasetpane() : view.currentContentView.openCardListPane();
		});
	}

}



// WEBPACK FOOTER //
// ./src/js/glass/controllers/OpenActionHandler.js